import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import Button from "@material-ui/core/Button";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import CustomizedAlert from "../../../../../ReusableComponents/Alert/CustomizedAlert";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 2200,
    color: "#fff",
    opacity: "1 !important",
  },
  root: {
    "& .MuiBackdrop-root": {
      opacity: "1 !important",
    },
  },
}));

const AddSaveNewTheme = (props) => {
  const [themeName, setThemeName] = useState();
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });

  const { t } = useTranslation();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const handleThemeName = (evt) => {
    let alphaNumericStr = "";
    const alphaNumericRegex = new RegExp(alphaNumericStr);
    if (alphaNumericRegex.test(evt.target.value)) {
      setThemeName(evt.target.value);
    } else {
      evt.preventDefault();
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentMsg: "Please enter a valid name",
        autoHideDuration: 4000
      });
    }
  };

  useEffect(() => {
    document.getElementById("backdropDiv")?.focus();
  }, []);
  function handleEscapeKey(e) {
    if (e.code === "Escape") {
      props.handleThemeNameBackdrop("cancel");
    }
  }

  const classes = useStyles();
  return (
    <Backdrop
      className={classes.backdrop + " " + classes.root}
      open={true}
      style={{ opacity: "1 !important" }}
    >
      <div
        tabIndex="0"
        onKeyDown={(e) => handleEscapeKey(e)}
        className={style.themeNameBackdropDiv}
        id="backdropDiv"
      >
        <Row className={style.themeNameBackdropHeader}>
          {props.themeAction ? props.themeAction : t("Save Theme")}
        </Row>
        <Row className={style.themeNameParentDiv}>
          <Col className={style.themeNameHeaderCol}>{t("Theme Name")}</Col>
          <Col className={style.themeNameCol}>
            <input
              aria-label={"Theme Name"}
              type="text"
              className={style.themeNameInput}
              autoFocus={true}
              maxLength={64}
              onKeyPress={(event) => handleThemeName(event)}
              onKeyUp={(event) => handleThemeName(event)}
              onBlur={(event) => handleThemeName(event)}
            />
          </Col>
          <Col className={style.ErrorMsg}>
            {props.showHelperText === true ? t("ENTER_THEME_NAME") : ""}
          </Col>
        </Row>
        <Row
          className={style.themeNameBackdropFooter}
          style={translationStyles1 ? { flexDirection: "row-reverse" } : null}
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.saveButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() =>
              props.handleThemeNameBackdrop(
                props.button1Name ? props.button1Name : "Save as",
                themeName
              )
            }
          >
            {props.button1Name ? props.button1Name : t("Save")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={[
              style.themeFooterButtons,
              style.cancelButton,
              "formBuilder-MuiButton-outlined",
            ].join(" ")}
            onClick={() => props.handleThemeNameBackdrop("cancel")}
          >
            {t("Cancel")}
          </Button>
        </Row>
      </div>
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </Backdrop>
  );
};

export default AddSaveNewTheme;
